import { z } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";

export const registrationFormSchema = toFormikValidationSchema(
    z.object({
        firstName: z.string("Registration.Error_FirstName_Required"),
        lastName: z.string("Registration.Error_LastName_Required"),
        email: z.email("Registration.Error_Email_Invalid").min(1, "Registration.Error_Email_Required"),
        password: z.string("Registration.Error_Password_Required").min(6, "Registration.Error_Password_6_Characters"),
        phoneNumber: z
            .string()
            .regex(/^(?:[0-9] ?){3,14}[0-9]$/g, "Registration.Error_PhoneNumber_Invalid")
            .optional(),
    }),
);

export const registrationInviteEmailFormSchema = toFormikValidationSchema(
    z.object({
        password: z.string("Registration.Error_Password_Required").min(6, "Registration.Error_Password_6_Characters"),
        email: z.email("Registration.Error_Email_Invalid").min(1, "Registration.Error_Email_Required"),
    }),
);
